module.exports = __webpack_public_path__ + "static/media/google_cloud-white.d3e9c529.svg";